const CSGO_STEAM_APP_ID = 730
// api to fetch all images under csgo app
export const STEAM_ITEM_IMAGES_URL = `https://api.steamapis.com/image/items/${CSGO_STEAM_APP_ID}`
// api to fetch single item image under csgo app
export const STEAM_ITEM_IMAGE_URL = `https://api.steamapis.com/image/item/${CSGO_STEAM_APP_ID}`
